var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg001Gewerbe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 428.98,
    height: 428.98,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    stroke: "null",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: -382.034,
    y: 172.6,
    width: 1.709,
    height: 0,
    id: "svg_46"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 78.876,
    y: 191.652,
    width: 19.715,
    height: 19.005,
    id: "svg_35",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f2f2f2",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 75.179,
    y: 203.055,
    width: 36.965,
    height: 252.76,
    id: "svg_28",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 414.024,
    y: 191.652,
    width: 19.715,
    height: 19.005,
    id: "svg_31",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 146.645,
    y: 190.385,
    width: 19.715,
    height: 19.005,
    id: "svg_34",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 215.646,
    y: 191.018,
    width: 19.715,
    height: 19.005,
    id: "svg_33",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 281.567,
    y: 189.118,
    width: 19.715,
    height: 19.005,
    id: "svg_32",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 345.023,
    y: 190.385,
    width: 19.715,
    height: 19.005,
    id: "svg_30",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#f2f2f2",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 75.179,
    y: 185.693,
    width: 360.407,
    height: 78.176,
    id: "svg_27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.761491,452.937806c3.699723,0 6.702704,-3.393447 6.702704,-7.574224l0,-181.788555c0,-4.180777 -3.002981,-7.574224 -6.702704,-7.574224l-281.524554,0c-3.699723,0 -6.702704,3.393447 -6.702704,7.574224l0,181.788555c0,4.180777 3.002981,7.574224 6.702704,7.574224s6.702704,-3.393447 6.702704,-7.574224l0,-174.214324l80.435587,0l0,174.214324c0,4.180777 3.002981,7.574224 6.702704,7.574224s6.702704,-3.393447 6.702704,-7.574224l0,-174.214324l174.277366,0l0,174.214324c0.000786,4.180777 3.003766,7.574224 6.703489,7.574224z",
    id: "svg_4",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.949891,311.138727c1.716326,0 3.431866,-0.675231 4.738944,-2.019231c2.621226,-2.695269 2.621226,-7.051154 0,-9.745616l-13.406193,-13.784885c-2.620441,-2.695269 -6.857448,-2.695269 -9.477889,0c-2.620441,2.695269 -2.620441,7.051154 0,9.745616l13.406193,13.784885c1.307078,1.343192 3.022619,2.019231 4.738944,2.019231l0.000001,0z",
    id: "svg_5",
    fill: "#777f8e",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f2f2f2",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 402.579,
    y: 201.788,
    width: 36.965,
    height: 252.76,
    id: "svg_29",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.385478,447.44192l-6.702704,0l0,-241.400409c0,-4.229901 -3.002981,-7.663207 -6.702704,-7.663207s-6.702704,3.433306 -6.702704,7.663207l0,241.400409l-67.029394,0l0,-45.981028l6.702704,0c3.699723,0 6.702704,-3.433314 6.702704,-7.663207s-3.002981,-7.663207 -6.702704,-7.663207l-26.8116,0c-3.699723,0 -6.702704,3.433314 -6.702704,7.663207s3.002981,7.663207 6.702704,7.663207l6.702704,0l0,45.981028l-40.217793,0l0,-76.634752l33.51509,0c3.699723,0 6.702704,-3.433306 6.702704,-7.663207s-3.002981,-7.663199 -6.702704,-7.663199l-80.435587,0c-3.699723,0 -6.702704,3.433306 -6.702704,7.663199s3.002981,7.663207 6.702704,7.663207l33.513519,0l0,76.634752l-40.217793,0l0,-45.981028l6.702704,0c3.699723,0 6.702704,-3.433314 6.702704,-7.663207s-3.002981,-7.663207 -6.702704,-7.663207l-26.8116,0c-3.699723,0 -6.702704,3.433314 -6.702704,7.663207s3.002981,7.663207 6.702704,7.663207l6.702704,0l0,45.981028l-160.871173,0l0,-241.400409c0,-4.229901 -3.002981,-7.663207 -6.702704,-7.663207c-3.699723,0 -6.702704,3.433306 -6.702704,7.663207l0,241.400409l-6.703489,0c-3.699723,0 -6.702704,3.433314 -6.702704,7.663207s3.002981,7.664104 6.702704,7.664104l388.771741,0c3.699723,0 6.702704,-3.433314 6.702704,-7.663207s-3.002195,-7.664104 -6.701918,-7.664104l-0.000003,0z",
    id: "svg_6",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 65.938,
    y: 152.376,
    width: 11.089,
    height: 48.145,
    id: "svg_37",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 65.322,
    y: 62.421,
    width: 380.122,
    height: 129.231,
    id: "svg_36",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 100.439,
    y: 155.543,
    width: 43.126,
    height: 48.145,
    id: "svg_39",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 168.824,
    y: 154.276,
    width: 43.126,
    height: 48.145,
    id: "svg_41",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 232.896,
    y: 156.81,
    width: 43.126,
    height: 48.145,
    id: "svg_42",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 301.281,
    y: 154.91,
    width: 43.126,
    height: 48.145,
    id: "svg_43",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 368.434,
    y: 154.91,
    width: 43.126,
    height: 48.145,
    id: "svg_44",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 435.587,
    y: 150.475,
    width: 11.089,
    height: 48.145,
    id: "svg_38",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.573092,49.23076l-335.147754,0c-18.480547,0 -33.51509,15.459231 -33.51509,34.461808l0,123.36531c0,2.074962 0.9049,4.032 2.460198,5.341269c1.561582,1.302808 3.606248,1.833462 5.577077,1.412654c10.704845,-2.233269 19.727142,-8.801423 25.471531,-17.69977c7.205426,11.165539 19.54569,18.533308 33.521374,18.533308c13.975683,0 26.302594,-7.361308 33.51509,-18.513116c7.212496,11.151808 19.54569,18.513116 33.51509,18.513116s26.302594,-7.361308 33.51509,-18.513116c7.210925,11.152616 19.544905,18.513923 33.513519,18.513923c13.969399,0 26.302594,-7.361308 33.51509,-18.513116c7.212496,11.151808 19.54569,18.513116 33.51509,18.513116c13.975683,0 26.302594,-7.361308 33.51509,-18.513116c7.212496,11.151808 19.54569,18.513116 33.51509,18.513116c13.975683,0 26.315948,-7.367769 33.521374,-18.533308c5.744389,8.898346 14.766685,15.4665 25.471531,17.69977c1.970829,0.434538 4.015495,-0.103385 5.577077,-1.412654c1.555297,-1.309269 2.460198,-3.267115 2.460198,-5.341269l0,-123.366118c-0.001571,-19.002577 -15.036113,-34.461808 -33.516661,-34.461808l-0.000004,0.000001zm20.108897,147.936119c-8.090689,-4.824346 -13.406193,-13.84627 -13.406193,-23.874577l0,-89.599733c0,-3.804231 -3.002981,-6.892039 -6.702704,-6.892039s-6.702704,3.087808 -6.702704,6.892039l0,89.599733c0,15.204808 -12.025277,27.568962 -26.8116,27.568962s-26.8116,-12.364962 -26.8116,-27.568962l0,-89.599733c0,-3.804231 -3.002981,-6.892039 -6.702704,-6.892039s-6.702704,3.087808 -6.702704,6.892039l0,89.599733c0,15.204808 -12.025277,27.568962 -26.8116,27.568962c-14.787109,0 -26.8116,-12.364962 -26.8116,-27.568962l0,-89.599733c0,-3.804231 -3.002981,-6.892039 -6.702704,-6.892039s-6.702704,3.087808 -6.702704,6.892039l0,89.599733c0,15.204808 -12.025277,27.568962 -26.8116,27.568962c-14.787109,0 -26.8116,-12.364962 -26.8116,-27.568962l0,-89.599733c0,-3.804231 -3.002981,-6.892039 -6.702704,-6.892039c-3.699723,0 -6.702704,3.087808 -6.702704,6.892039l0,89.599733c0,15.204808 -12.025277,27.568962 -26.8116,27.568962s-26.8116,-12.364962 -26.8116,-27.568962l0,-89.599733c0,-3.804231 -3.002981,-6.892039 -6.702704,-6.892039s-6.702704,3.087808 -6.702704,6.892039l0,89.599733c0,15.204808 -12.025277,27.568962 -26.8116,27.568962c-14.787109,0 -26.8116,-12.364962 -26.8116,-27.568962l0,-89.599733c0,-3.804231 -3.002981,-6.892039 -6.702704,-6.892039c-3.699723,0 -6.702704,3.087808 -6.702704,6.892039l0,89.599733c0,10.028308 -5.315504,19.050231 -13.406193,23.874577l0,-113.47431c0,-11.399769 9.022296,-20.676924 20.108897,-20.676924l335.14854,0c11.0866,0 20.108897,9.277154 20.108897,20.676924l0,113.47431l-0.005499,0l-0.000001,0z",
    id: "svg_7",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.563628,345.599728l0,13.784885c0,3.804231 3.002981,6.892039 6.702704,6.892039c3.699723,0 6.702704,-3.087808 6.702704,-6.892039l0,-13.784885c0,-3.804231 -3.002981,-6.892039 -6.702704,-6.892039c-3.699723,0 -6.702704,3.087808 -6.702704,6.892039z",
    id: "svg_8",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.993153,299.373073c-2.621226,2.695269 -2.621226,7.051154 0,9.745616l26.8116,27.568962c1.307078,1.344 3.023404,2.019231 4.738944,2.019231c1.716326,0 3.431866,-0.675231 4.738944,-2.019231c2.621226,-2.695269 2.621226,-7.051154 0,-9.745616l-26.8116,-27.568962c-2.621226,-2.694462 -6.857448,-2.694462 -9.477889,0l0.000001,0z",
    id: "svg_9",
    fill: "#777f8e",
    stroke: "null"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001Gewerbe);
export default __webpack_public_path__ + "static/media/001 Gewerbe.5fce56aa659fc09560497cfa89974600.svg";
export { ForwardRef as ReactComponent };